var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGymEW(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.37921 35.8625L8 37.2417L10.7584 40L12.1376 38.6208",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 33.5124V33.5146C8 34.1347 8.24716 34.7305 8.68519 35.1685L12.8317 39.3148C13.2697 39.7529 13.8644 40 14.4856 40H14.4878C15.7799 40 16.827 38.9529 16.827 37.6609V37.6587C16.827 37.0387 16.5798 36.4429 16.1418 36.0048L11.9953 31.8585C11.5573 31.4205 10.9626 31.1734 10.3414 31.1734H10.3391C9.0471 31.1734 8 32.2204 8 33.5124Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8623 9.38035L37.2415 8.00118L39.9999 10.7595L38.6207 12.1387",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.512 8.00136H33.5142C34.1343 8.00136 34.7301 8.24851 35.1682 8.68653L39.3146 12.8328C39.7527 13.2709 39.9998 13.8667 39.9998 14.4867V14.4889C39.9998 15.7809 38.9527 16.828 37.6607 16.828H37.6585C37.0373 16.828 36.4426 16.5809 36.0045 16.1428L31.858 11.9965C31.42 11.5585 31.1729 10.9627 31.1729 10.3426V10.3404C31.1729 9.04842 32.22 8.00136 33.512 8.00136Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.126 17.0921L17.0913 28.1263",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.874 30.9084L30.9087 19.8742",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.91367 28.7767L19.2245 39.086C19.8093 39.6719 20.6038 39.9996 21.4314 39.9996C23.1539 39.9996 24.552 38.6027 24.552 36.8791C24.552 36.0516 24.2232 35.2582 23.6383 34.6723L13.3275 24.363C12.7427 23.7771 11.9482 23.4483 11.1206 23.4483C9.39699 23.4483 8 24.8452 8 26.5698C8 27.3974 8.32883 28.1908 8.91367 28.7767Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7753 8.91475L39.0861 19.2241C39.6709 19.81 39.9998 20.6033 39.9998 21.4309C39.9998 23.1545 38.6017 24.5514 36.8792 24.5514C36.0516 24.5514 35.2571 24.2237 34.6722 23.6378L24.3614 13.3285C23.7766 12.7425 23.4478 11.9492 23.4478 11.1216C23.4478 9.39695 24.8447 8.00001 26.5684 8.00001C27.396 8.00001 28.1905 8.32884 28.7753 8.91475Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGymEW);
export default __webpack_public_path__ + "static/media/gymE-w.d20a6f752696e07a9ddf0d4ef1449d7b.svg";
export { ForwardRef as ReactComponent };